import Inventory from '@app/features/inventory/Inventory';

const InventoryPage = () => <Inventory />;
export default InventoryPage;
